module.exports = __webpack_public_path__ + "static/assets/scan-green-new.svg";